import React, { useState } from "react";
import styles from "./RSVPTidbits.module.css";
import {
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { FiPlus } from "react-icons/fi";
import { List } from "antd";
import { FaPen } from "react-icons/fa";
import Modal from "../../../../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import { useNavigate } from "react-router-dom";
import { TiDelete } from "react-icons/ti";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
const RSVPTidbits = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [isTidbitsModalOpen, setisTidbitsModalOpen] = useState(false);
  const [isMealModalOpen, setisMealModalOpen] = useState(false);
  const [tidbits, setTidbits] = useState("");
  const [tidbitsIndex, setTidbitsIndex] = useState("");
  const [tidbitsArr, setTidbitsArr] = useState(
    RSVP?.tidbits?.length > 0 ? RSVP?.tidbits : []
  );
  const [mealsArr, setMealsArr] = useState(
    RSVP?.meals?.length > 0 ? RSVP?.meals : []
  );

  const [mealStates, setMealStates] = useState();

  console.log("tidbitsIndex", tidbitsIndex);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const saveDetails = () => {
    if (!tidbits) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      let dummyArr = [...tidbitsArr];
      if (tidbitsIndex?.index >= 0) {
        dummyArr.splice(tidbitsIndex?.index, 1, {
          id: tidbitsIndex?.id,
          question: tidbits,
        });
      } else {
        dummyArr.push({
          question: tidbits,
        });
      }
      setTidbitsIndex(null);
      setTidbitsArr(dummyArr);
      setisTidbitsModalOpen(false);
      setTidbits("");
    }
  };
  const onEditTidbitsIcon = (item, index) => {
    setTidbits(item?.question);
    setTidbitsIndex({ index, id: item?.id });
    setisTidbitsModalOpen(true);
  };

  const onCreateRsvp = () => {
    if (!tidbitsArr?.length > 0 || !mealsArr?.length > 0) {
      dispatch(
        showAlert({
          title: "createRsvp",
          message: "Please enter meals and tidbitds",
          type: "Error",
        })
      );
    } else {
      dispatch(
        EventPlanningMiddleware.createRsvp({
          ...RSVP,
          mealsArr,
          tidbitsArr,
          event_id: EventDetails?.id,
        })
      ).then(() => navigate("/events/RSVPCelebrate"));
    }
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.TB_header}>
        <TextComponent text={"Tidbits"} textClass={styles.TB_heading} />
        <div
          className={styles.addQues}
          onClick={() => {
            setTidbits("");
            setTidbitsIndex(null);
            setisTidbitsModalOpen(true);
          }}
        >
          {/* <FiPlus className={styles.plusIcon} /> */}
          <TextComponent
            text={"+ Add Question"}
            textClass={styles.addQuesText}
          />
        </div>
      </div>
      <List
        className={styles.TB_list}
        dataSource={tidbitsArr}
        renderItem={(item, index) => {
          return (
            <div className={styles.TB_ListItem} key={index}>
              <div className={styles.TB_listText}>
                <TextComponent text={item?.question} />
              </div>
              <FaPen
                className={styles.penIcon}
                onClick={() => onEditTidbitsIcon(item, index)}
              />
              <TiDelete
                className={styles.penIcon}
                size={20}
                onClick={() =>
                  setTidbitsArr((prev) => {
                    prev.splice(index, 1);
                    return [...prev];
                  })
                }
              />
            </div>
          );
        }}
      />

      <div className={styles.mealDiv}>
        <div className={styles.M_header}>
          <TextComponent text={"Meal Question"} textClass={styles.M_heading} />
          <div
            className={styles.addQues}
            onClick={() => {
              setMealStates(null);
              setisMealModalOpen(true);
            }}
          >
            {/* <FiPlus className={styles.plusIcon} /> */}
            <TextComponent text={"+ Add Meal"} textClass={styles.addQuesText} />
          </div>
        </div>
        <List
          dataSource={mealsArr}
          className={styles.M_list}
          renderItem={(item, index) => {
            return (
              <div className={styles.M_listItem}>
                <div className={styles.mealText}>
                  <TextComponent text={item?.name} textClass={styles.meal} />
                  <TextComponent
                    text={item?.description}
                    textClass={styles.meal_desc}
                  />
                </div>
                <FaPen
                  className={styles.penIcon}
                  size={14}
                  onClick={() => {
                    setisMealModalOpen(true);
                    setMealStates({ ...item, index });
                  }}
                />
                <TiDelete
                  className={styles.penIcon}
                  size={25}
                  onClick={() =>
                    setMealsArr((prev) => {
                      prev.splice(index, 1);
                      return [...prev];
                    })
                  }
                />
              </div>
            );
          }}
        />
      </div>
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Create RSVP"
          btnClass={styles.btn}
          onClick={() => {
            onCreateRsvp();
            // navigate("/events/RSVPCelebrate");
          }}
          // onClick={()=>navigate("/events/RSVPTidbits",{
          //     state: {
          //         headertitle: "Tidbits"
          //     }
          // })}
          //   onClick={() => setrsvpModal(true)}
        />
      </div>
      <Modal
        // pinkBg
        isModalOpen={isTidbitsModalOpen}
        setIsModalOpen={setisTidbitsModalOpen}
        closable={true}
        className={styles.TB_modal}
      >
        <div className={styles.TB_modalCon}>
          <TextComponent
            text={`${tidbitsIndex?.index >= 0 ? "Edit " : "Add "}` + "Question"}
            textClass={styles.TB_modalHeading}
          />
          <InputField
            label={"Your Question"}
            placeholder={"Add question here"}
            value={tidbits}
            onChange={(e) => setTidbits(e.target.value)}
          />
          <SubmitButton
            title={"Save Question"}
            btnClass={styles.TB_Btn}
            onClick={saveDetails}
          />
        </div>
      </Modal>
      {isMealModalOpen && (
        <Modal
          // pinkBg
          isModalOpen={isMealModalOpen}
          setIsModalOpen={setisMealModalOpen}
          closable={true}
          className={styles.TB_modal}
        >
          <div className={styles.TB_modalCon}>
            <div className={styles.M_modalHeading}>
              <TextComponent
                text={`${mealStates?.index >= 0 ? "Edit" : "Add"} Meal`}
              />
            </div>
            <TextComponent
              text={"Add information"}
              textClass={styles.M_modalsubHeading}
            />
            <InputField
              placeholder={"Meal name"}
              value={mealStates?.name}
              onChange={(e, index) => {
                // let array = [...mealStates];
                // array[index]?.meal_name = e.target.value;
                // setMealStates(arr);
                setMealStates({
                  ...mealStates,
                  name: e.target.value,
                });
              }}
            />
            <InputField
              placeholder={"Description"}
              value={mealStates?.description}
              onChange={(e) => {
                setMealStates({
                  ...mealStates,
                  description: e.target.value,
                });
              }}
            />
            <SubmitButton
              title={"Save"}
              btnClass={styles.TB_Btn}
              onClick={() => {
                if (mealStates?.index >= 0) {
                  setMealsArr((prev) => {
                    prev.splice(mealStates?.index, 1, mealStates);
                    return [...prev];
                  });
                } else {
                  setMealsArr([mealStates, ...mealsArr]);
                }
                setisMealModalOpen(false);
              }}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default RSVPTidbits;
